var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAddUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.984 0a1 1 0 0 0-1 1v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0V5h2a1 1 0 0 0 0-2h-2V1a1 1 0 0 0-1-1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.941 5.707c-.09.903-.322 1.732-.657 2.339-.411.744-.836.954-1.3.954-.464 0-.888-.21-1.3-.954-.44-.796-.7-1.977-.7-3.206 0-2.114 1.176-2.84 2-2.84.454 0 1.013.22 1.425.768A1.997 1.997 0 0 1 10.984 2h.302c-.72-1.26-1.93-2-3.302-2-2.209 0-4 1.924-4 4.84s1.2 6.16 4 6.16c2.432 0 3.657-2.446 3.937-5h-.937a1.99 1.99 0 0 1-1.043-.293Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.608 8.266-2.416.762a4 4 0 0 0-2.73 3.084L.067 14.24c-.318 1.71.88 3.327 2.613 3.471 1.757.146 3.95.289 5.802.289 1.853 0 4.047-.143 5.807-.289 1.734-.143 2.932-1.763 2.612-3.473l-.397-2.129a4 4 0 0 0-2.729-3.08L10.514 8c-.25.731-.625 1.34-1.08 1.757l3.74 1.18a2 2 0 0 1 1.364 1.54l.397 2.128c.109.582-.296 1.07-.812 1.113-1.742.145-3.871.282-5.64.282-1.77 0-3.897-.137-5.638-.282-.516-.043-.92-.53-.812-1.112l.396-2.129a2 2 0 0 1 1.364-1.542l3.06-.965c-.513-.363-.946-.96-1.245-1.704Z"
}))));
export default SvgIconAddUser;